import select from './DictItemMultipleSelect.vue'
const FormDictItemMultipleSelect = {
  install: function (Vue) {
    Vue.component('FormDictItemMultipleSelect', select)
  }
}
export default FormDictItemMultipleSelect
